"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = {
  alt: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  children: _propTypes["default"].node,
  imgSrc: _propTypes["default"].string,
  initials: _propTypes["default"].string,
  textColor: _propTypes["default"].string
};